module.exports = __webpack_public_path__ + "static/media/book.a747dfd5.svg";